<template>
    <div class="xi">
        <hd-com></hd-com>
        <searchhdCom></searchhdCom>
           <div class="content-wrap">
            <div class="center-box">
                <div class="content clearfix" style="position: relative;">
                     <div class="center-center flex-start flex-wrap">
                        <div class="shopGoodBox">
                            <div>
                                <div class="shopGoodBoxTop">选择付款方式</div>
                                <div class="shopGoodBoxOrd">交易号：{{orderNum}}</div>
                            </div>
                            <div class="shopGoodBoxPay">
                                <div class="shopGoodBoxPayTitle">支付方式</div>
                                <div class="shopGoodBoxPayType">
                                    <el-form class="dialog-form" :model="charge" ref="chargeForm">
                                        <el-form-item label="应收金额" style="color: #ff0000" class="numT">
                                        <span style="font-size: 25px"><span style="font-size: 14px">￥</span>{{ totalMoney}}</span>
                                        </el-form-item>
                                        <el-form-item label="付款方式">
                                        <el-radio-group v-model="charge.payWay" @input='chargePayWayInput'>
                                            <el-radio :label="1">微信</el-radio>
                                            <el-radio :label="2">支付宝</el-radio>
                                            <el-radio :label="0" :disabled="assetsBalanceIsTrue">余额</el-radio><span
                                            style="font-size: 14px; color: #ff0000">（可用余额：￥{{ UserBalance.assetsBalance }}）</span>
                                        </el-radio-group>
                                        </el-form-item>
                                        <template v-if="charge.payWay == 0">
                                        <el-form-item label="支付密码" prop="payPwd"> <el-input type="password" maxlength="6" v-model="charge.payPwd"
                                            show-password style="width: 200px"></el-input><span
                                            style="font-size: 14px; color: #00afb5; margin-left: 5px; cursor: pointer" @click="getPayPwd">忘记密码？</span>
                                        </el-form-item>
                                        </template>
                                        <template v-if="charge.payWay == 1">
                                        <div class="flex-space-between-columns" v-if="qRcodeUrl">
                                            <img style="width: 120px; height: 120px" :src="qRcodeUrl" alt="Base64 Image" />
                                            <div>
                                            <span>打开微信扫码支付~ </span>
                                            <span style="font-size: 14px; color: #00afb5; margin-left: 5px; cursor: pointer">刷新</span>
                                            </div>
                                        </div>
                                        </template>
                                        <template v-if="charge.payWay == 2">
                                        <div class="flex-space-between-columns" v-if="qRcodeUrlZ">
                                            <img style="width: 120px; height: 120px" :src="qRcodeUrlZ" alt="Base64 Image" />
                                            <div>
                                            <span>打开支付宝扫码支付~ </span>
                                            <span style="font-size: 14px; color: #00afb5; margin-left: 5px; cursor: pointer">刷新</span>
                                            </div>
                                        </div>
                                        </template>
                                    </el-form>
                                    <div class="flex-l-s">
                                        <div></div>
                                        <div slot="footer" class="dialog-footer">
                                            <el-button @click="cancleSaveBtn('chargeForm')">取 消</el-button>
                                            <el-button type="primary" @click="SaveBtn('chargeForm')">确 定</el-button>
                                        </div>
                                    </div>
          
                                </div>
                            </div>
                        </div>
   
                     </div>
                </div>
            </div>
           </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>


import hdCom from '../../components/intshopheader'
import searchhdCom from '../../components/insearchHeader'
import { Outpatient } from "@/components/Drug/Outpatient";
import ftCom from '../../components/footer'
// import rtBar from "../../components/right";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall"
export default {
    name: "healthKnow",
    components: {
        hdCom,
        searchhdCom,
        ftCom,
        // rtBar
    },
    data() {
        var shoppingMall1 = new shoppingMall(this.TokenClient, this.Services.shoppingMall)
        var shoppingMall2 = new shoppingMall(this.TokenClient, this.Services.Authorization)
        var outpatientAuthorization = new Outpatient(this.TokenClient, this.Services.Authorization);
        return {
            shoppingMallDomain: shoppingMall1,
            shoppingMallDomain2: shoppingMall2,
            outpatientAuthorizationDomain: outpatientAuthorization,
            DetailData:{},
            payType:0,
            assetsBalanceIsTrue:false,
            orderNum:this.$route.query.order,
            totalMoney:this.$route.query.totalMoney,
            wxpayType:0,
            qRcodeUrl:'',
            qRcodeUrlZ:'',
            UserBalance: {
                assetsBalance: 0,
            },
            charge: {
                payWay: 1, //0 现金 1微信支付，2支付宝，3银行卡 4 挂账 5 其他
                payPwd:''
            },
            timerZ:null,
            timer:null,
            leadOrderNumber:''
        }
    },
    destroyed(){
        this.chargePayWayInput()
    },
    methods: {
        getPayPwd() {
            const href = this.$router.resolve("../personal/resetPassword");
            window.open(href.href, "_blank");
        },
        chargePayWayInput(){
            clearInterval(this.timer);
            clearInterval(this.timerZ);
            this.qRcodeUrl = ''
            this.qRcodeUrlZ = ''
        },
        SaveBtn() {
            var _this = this;
            let paramsTotal = {
                clientType:2,
                leadOrderNumber: _this.$route.query.order,
                payType: _this.charge.payWay,
            }
            if (_this.charge.payWay == 0) {
            _this.outpatientAuthorizationDomain.getIsSetPayPassword(
            function (data) {
                _this.outpatientAuthorizationDomain.getIsPayPassword(
                {
                    payPassword: _this.charge.payPwd,
                },
                function (data) {
                    _this.shoppingMallDomain.SingeSubmitPay(paramsTotal, function (data) {
                        _this.leadOrderNumber = data.data.orderNum
                            _this.shoppingMallDomain.getVerificationSuccessPay(
                            _this.leadOrderNumber,
                            function (data) {
                                _this.$message({
                                    type: "success",
                                    message: "支付成功!",
                                });
                                 _this.toSucess()
                                _this.qRcodeUrl = ''
                                _this.leadOrderNumber = ''
                            },
                            function (error) {
                                _this.toFail()
                                console.log(error);
                            }
                            );
                    })
                },
                function (error) {
                    _this.$message({
                    type: "info",
                    message: "支付密码错误",
                    });
                }
                );
            },
            function (error) {
                _this
                .$confirm("未设置支付密码？去设置", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    const href = _this.$router.resolve("../personal/resetPassword");
                    window.open(href.href, "_blank");
                });
            }
            );
        } else if (_this.charge.payWay == 1) {
            _this.shoppingMallDomain.SingeSubmitPay(paramsTotal, function (data) {
                _this.qRcodeUrl = 'data:image/jpeg;base64,' + data.data.qRcodeBase64
                _this.leadOrderNumber = data.data.orderNum
                var isSuccess = false;
                _this.timer = window.setInterval(() => {
                setTimeout(function () {
                    _this.shoppingMallDomain.getVerificationSuccessPay(
                    _this.leadOrderNumber,
                    function (data2) {
                        isSuccess = data2.data.state == 1 ? true : false;
                        if (isSuccess) {
                        clearInterval(_this.timer);
                        _this.$message({
                            type: "success",
                            message: "支付成功!",
                        });
                        _this.toSucess()
                        _this.qRcodeUrl = ''
                        _this.leadOrderNumber = ''
                        }
                    },
                    function (error) {
                        _this.toFail()
                        console.log(error);
                    }
                    );
                }, 0);
                }, 5000);
            },
            function (error) {

            })
        } else  {
            _this.shoppingMallDomain.SingeSubmitPay(paramsTotal, function (data) {
                _this.qRcodeUrlZ = 'data:image/jpeg;base64,' + data.data.qRcodeBase64
                _this.leadOrderNumber = data.data.orderNum
                var isSuccess = false;
                _this.timerZ = window.setInterval(() => {
                setTimeout(function () {
                    _this.shoppingMallDomain.getVerificationSuccessPay(
                    _this.leadOrderNumber,
                    function (data2) {
                        isSuccess = data2.data.state == 1 ? true : false;
                        if (isSuccess) {
                        clearInterval(_this.timerZ);
                        _this.$message({
                            type: "success",
                            message: "支付成功!",
                        });
                         _this.toSucess()
                        _this.qRcodeUrlZ = ''
                        _this.leadOrderNumber = ''
                        }
                    },
                    function (error) {
                        _this.toFail()
                        console.log(error);
                    }
                    );
                }, 0);
                }, 5000);
            })
            }
        },
        getAllUserBalance() {
        var _this = this;
            _this.shoppingMallDomain2.getUserDistributor(
                function (data) {
                _this.UserBalance = data.data;
                if (_this.UserBalance.assetsBalance * 1 < _this.totalMoney * 1) {
                    _this.assetsBalanceIsTrue = true;
                    _this.charge.payWay = 1;
                } else {
                    _this.assetsBalanceIsTrue = false;
                }
                },
                function (err) {
                _this.UserBalance = [];
                console.log(err);
                }
            );
        },
        //详情获取
        Detail() {
            var _this = this;
            let paramsTotal = {
                clientType:2,
                leadOrderNumber: _this.$route.query.order,
                payType: _this.wxpayType,
            }
            _this.shoppingMallDomain.SingeSubmitPay(paramsTotal, function (data) {
                this.qRcodeUrl = data.data.qRcodeBase64
            },
            function (error) {

            })
        },
        toSucess(){
            var _this = this
            _this.$router.push({
                path: './shopSuccess',
                query: {
                    order: 0
                }
            })
            
        },
        toFail(){
            var _this = this
            _this.$router.push({
                path: './shopSuccess',
                query: {
                    order: 1
                }
            })
        },
    },
    mounted() {
        // this.Detail();
        this.getAllUserBalance()
    },
    destroyed() {
        //销毁监听
    },
}
</script>
<style lang="scss" scoped>
.flex-l-s {
    display: flex;
    justify-content: space-between;
}
.shopTab {
    border-bottom: 1px solid #E6E6E6;
}
.shopTabBox {
    display: flex;
    align-items: center;
}
.shopTabno {
    font-size: 15px;
    // color: #FFFFFF;
    font-weight: bold;
    padding: 10px 50px;
    cursor: pointer;
}
.shopTabChecked {
    font-size: 15px;
    padding: 10px 50px;
     cursor: pointer;
}
.tagcomCheck {
    padding: 5px 15px;
    border-radius: 2px;
    border: 1px solid #00AFB5;
    font-size: 14px;
    color: #00AFB5;
    margin-left: 10px;
    cursor: pointer;
}
.tagcom {
    padding: 5px 15px;
    background: #F0F0F0;
    border-radius: 2px;
    font-size: 14px;
    margin-left: 10px;
    color: #333333;
    cursor: pointer;
}

.banner {
    height: 116px;
    background: url("../../assets/img/jbk_banner.png")center no-repeat;
}
.shopGoodBox {
    width: 100%;
    background: #FFFFFF;
    border-radius: 2px;
    padding: 30px;
}
.flex-l {
    display: flex;
    align-items: center;
}
.shopGoodBoxTop {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}
.shopGoodBoxPayTitle {
    background: #F5F5F5;
    padding: 13px 20px;
    color: #999999;
}
.shopGoodBoxPayType {
    padding: 30px 20px;
     min-height: 400px;
}
.shopGoodBoxPay {
    width: 100%;
    border: 1px solid #E0E0E0;
    background: #FFFFFF;
   
    margin-top: 15px;
}
.shopGoodBoxOrd {
    font-size: 14px;
    color: #999999;
}
.shopGoodBoxRight {
    margin-left: 60px;
}
.shopGoodBoxName {
    font-weight: bold;
    font-size: 20px;
    color: #1A1A1A;
}
.shopGoodPrice {
    font-size: 24px;
    color: #E1251B;
    margin-bottom: 30px;
}
.shopGoodBot {
    margin-top: 30px;
}
.shopGoodBoxSold {
    font-size: 16px;
    color: #CCCCCC;
}
.banner-text {
    width: 1200px;
    margin: 0 auto;

    h3 {
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }

    p {
        font-size: 18px;
        color: #ffffff;

        a {
            color: #ffffff;
            font-size: 14px;
            margin: 0 5px;
        }
    }
}

.content-wrap {
    background: #F5F6F6;
}


.content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;

}

.menu-box {
    width: 100%;
    background: #fff;
    height: auto;

    .box {
        align-items: flex-start !important;
        margin-bottom: 10px;
    }

    .menu-title {
        width: 90px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-content {
        width: calc(100% - 95px);
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-item {
        width: auto;
        margin: 0 5px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 40px;
        padding: 0 10px;
    }

    .menu-item:hover {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
        cursor: pointer;
    }

    .menuActive {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
    }
}



.healthKnow .el-radio {
    margin-right: 30px;
}

#page ::v-deep .el-pagination {
    text-align: center;
    margin: 30px auto;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    background-color: #fff;
}

#page ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #01C2AC;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    border-radius: 2px;
}
</style>
